export class TimeoutError extends Error {
    constructor() {
        super("timeout");
    }
}

export async function timeout<T>(ms: number, promise: Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
        let timedOut = false;
        const timer = setTimeout(() => {
            reject(new TimeoutError());
            timedOut = true;
        }, ms);
        promise
            .then((res) => {
                if (timedOut) {
                    return res;
                }
                clearTimeout(timer);
                resolve(res);
                return res;
            })
            .catch((err) => {
                if (timedOut) {
                    return;
                }
                clearTimeout(timer);
                reject(err);
            });
    });
}

export class PromiseMonitor<R = void> {
    private _status: "pending" | "resolved" | "rejected" = "pending";
    private _isPending = true;
    private _isResolved = false;
    private _isRejected = false;
    private _error: Error | undefined;
    private _result: R | undefined;

    constructor(prm: Promise<R>) {
        // eslint-disable-next-line promise/catch-or-return
        prm.then(
            (result) => {
                this._status = "resolved";
                this._isResolved = true;
                this._isPending = false;
                this._result = result;
                return result;
            },
            (err) => {
                this._status = "rejected";
                this._isPending = false;
                this._isRejected = true;
                this._error = err instanceof Error ? err : new Error("unknown error");
                // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                return err;
            },
        );
    }

    public get status(): string {
        return this._status;
    }

    public get isPending(): boolean {
        return this._isPending;
    }

    public get isResolved(): boolean {
        return this._isResolved;
    }

    public get isRejected(): boolean {
        return this._isRejected;
    }

    public get error(): Error | undefined {
        return this._error;
    }

    public get result(): R | undefined {
        return this._result;
    }
}
